<template>
  <div class="CouponPulldown" v-if="couponList.length">
    <div class="coupon-card" v-if="couponIndex !== -1">
      <div class="coupon-info">
        <div class="coupon-price-wrap">
          <template v-if="couponType == 1">
            <i class="icon_dollar">¥</i>
            <span
              class="coupon-price"
              :class="{ 'long': couponPrice > 99 }"
            >{{ couponPrice | disposePrice }}</span>
          </template>

          <template v-if="couponType == 2">
            <span
              class="coupon-price coupon-price-zk"
            >{{ couponPrice | disposePrice }}折</span>
          </template>
          <template v-if="couponType == 3">
            <span
              class="coupon-price coupon-price-mysy"
            >买一送一</span>
          </template>


<!--          couponType-->

        </div>
        <div class="coupon-name">优惠券</div>
      </div>
      <div class="coupon-count-down">
        <!--  未选中 -->
        <span style="display:flex;" v-if="remainTime < countdownTime">
          倒计时<CountDown :remain-time="remainTime / 1000"/>
        </span>
        <span v-else>
          有效期:{{ remainTimeStr | disposeEndTime2 }}
        </span>
      </div>
      <i class="iconfont icon-a-arrowupbold"></i>
    </div>

    <div class="coupon-card coupon-card-unselect" v-else>
      <div class="coupon-info">
        <i class="icon_quan">¥</i>
        <div class="coupon-name">优惠券</div>
      </div>
      <div class="coupon-count-down">
        <span>
          {{ couponList.length }} 张可用
        </span>
      </div>
      <i class="iconfont icon-a-arrowupbold"></i>
    </div>

    <div class="coupon-list-wrap">
      <div class="title">选择优惠券</div>
      <div class="coupon-list">
        <div
          class="coupon-item _user-select"
          :class="{ 'active': idx === couponIndex }"
          v-if="couponList"
          v-for="(vo,idx) in couponList"
          @click="toggleCoupon(vo,idx)"
        >
          <i
            :class="{ 'icon-user-radio2': idx === couponIndex }"
            class="iconfont icon-user-radio"
          />
          <div class="coupon-item-info">
            <div class="coupon-item-info-left">
              <div class="price-wrap">

                <template v-if="vo.type == 1">
                  <i class="icon_dollar">¥</i>
                  <span class="price">{{ vo.discount_amount | disposePrice }}</span>
                </template>

                <template v-if="vo.type == 2">
                  <span
                    class="price price-zk"
                  >{{ vo.discount_amount | disposePrice }}</span>
                  <i class="txt-zhe">折</i>
                </template>

                <template v-if="vo.type == 3">
                  <span
                    class="price price-mysy"
                  >买一送一</span>
                </template>


              </div>
              <div class="coupon-item-type">{{ vo.name }}</div>
            </div>
            <span class="line"></span>
            <div class="coupon-item-info-right">
              <div class="coupon-name">{{ vo | disposeModule }}<template v-if="vo.discount_limit > 0">，最高减{{ vo.discount_limit | disposePrice }}</template></div>
              <div class="coupon-time">有效期至{{ vo.end_time | disposeEndTime }}</div>
            </div>


          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import CountDown from '@/components/act/new-user-coupon/count-down'
import {toolDate} from "@/tools";

export default {
  name: "CouponPulldown",
  components: {
    CountDown
  },
  props: {
    /* couponPrice: {
       type: String | Number,
       default: 0
     },*/
    couponList: {
      type: Array,
      default: () => []
    },
    discountPrice:{
      type: Number | String,
      default: 0
    }
  },
  data() {
    return {
      remainTime: 0,
      couponIndex: -1,
      couponPrice: 0,
      countdownTime: 12 * 60 * 60 * 1000, // 12小时转为毫秒
      couponType: -1,
    }
  },
  watch: {
    couponList: {
      handler(n, o) {
        if (this.couponList.length) {
          this.couponIndex = 0;
          this.couponPrice = this.couponList[0].discount_amount;
          this.remainTime = this.couponList[0].end_time * 1000 - new Date().getTime();
          this.remainTimeStr = this.couponList[0].end_time;
          this.couponType = this.couponList[0].type;

        } else {
          this.couponPrice = 0;
          this.remainTime = 0;
          this.couponIndex = -1;
          this.couponType = -1;
        }
      },
      deep: true,
      immediate:true
    },
    couponIndex(n, o) {
      console.log('couponIndex')
      console.log(n)
      if (n != -1) {
        if (this.couponList.length) {
          this.remainTime = this.couponList[n].end_time * 1000 - new Date().getTime();
          this.remainTimeStr = this.couponList[n].end_time;
          this.couponPrice = this.couponList[n].discount_amount;
          this.couponType = this.couponList[n].type;
        }
      }
    }
  },
  methods: {
    toggleCoupon(vo, idx) {
      if (idx == this.couponIndex) {
        this.couponIndex = -1;
      } else {
        this.couponIndex = idx;
      }
      console.log(this.couponIndex)

      this.$emit('toggleCoupon', {
        selectCoupon: vo,
        isSelect: this.couponIndex == -1 ? false : true
      })
    },
    disposePrice(val) {
      return parseFloat(val).toFixed(0);
    },
  },
  filters: {
    disposePrice(val) {
      let tempVal = parseFloat(val).toFixed(1);
      if (tempVal.charAt(tempVal.length - 1) == 0){
        return tempVal.slice(0,tempVal.length - 2)
      }else{
        return tempVal;
      }


    },
    disposeModule(vo) {
      let str;
      switch (parseInt(vo.module)) {
        case 1:
          str = '个人VIP';
          break;
        case 2:
          str = '个人VIP';
          break;
        case 3:
          str = '企业VIP';
          break;
        case 0:
          str = '全站VIP';
          // return '全站通用'
          break;
        default:
          str = '全站VIP'
          break;
      }


      // if (vo.require_amount > 0 && vo.module > 0) {
      if (vo.require_amount > 0) {
        vo.require_amount = parseFloat(vo.require_amount).toFixed();
        str = str + `满${vo.require_amount}可用`
      }else{
        str = str + `可用`
      }
      return str;
    },
    disposeEndTime(time) {
      let timeStr = toolDate.timestampConversion(time * 1000);
      let {
        year,
        month,
        day,
        hours,
        minutes,
        seconds
      } = timeStr;
      return `${month}月${day}日${hours}:${minutes}`;
    },
    disposeEndTime2(time) {
      let timeStr = toolDate.timestampConversion(time * 1000);
      let {
        year,
        month,
        day,
        hours,
        minutes,
        seconds
      } = timeStr;
      return `${month}月${day}日`;
    }
  }
}
</script>

<style lang="scss" scoped>
.CouponPulldown {
  display: inline-block;
  cursor: pointer;
  position: relative;


  .coupon-card {
    @include BgImage(126px, 41px, 'pay/coupon/coupon-pulldown/coupon.svg');
    position: relative;

    &:after{
      content: '';
      display: inline-block;
      width: 20px;
      height: 100%;
      @include Position(1,2,-18px,0);
    }

    .coupon-info {
      font-size: 0;
      display: flex;

      .coupon-price-wrap {
        font-size: 0;
        width: 46px;
        text-align: center;

        .icon_dollar {
          font-size: 10px;
          font-weight: bold;
          color: #FF5100;
          line-height: 14px;
        }

        .coupon-price {
          height: 24px;
          font-size: 18px;
          font-weight: bold;
          color: #FF3017;
          line-height: 24px;

          &.coupon-price-zk{
            font-size: 14px;
          }

          &.coupon-price-mysy{
            font-size: 9px;
          }



          &.long {
            font-size: 16px;
          }
        }
      }

      .coupon-name {
        display: inline-block;
        height: 14px;
        line-height: 14px;
        margin: 5px 0 5px 0;
        padding-left: 10px;
        border-left: 1px dashed #C36F43;
        box-sizing: border-box;
        font-size: 12px;
        color: #C36F43;
      }
    }

    .coupon-count-down {
      //width: 92px;
      margin-right: 23px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      color: #FF3017;
      line-height: 16px;

      /deep/ .CountDown {
        font-size: 11px;
        color: #FF3017;
        line-height: 16px;
        margin-left: 3px;
      }
    }

    .icon-a-arrowupbold {
      font-size: 16px;
      color: #717792;
      @include Position(1, 2, 4px, 13px);
      transform: rotateZ(-90deg);
      transition: all 0.3s ease-in;
    }


  }

  .coupon-card-unselect {
    .coupon-info {
      display: flex;
      align-items: center;
    }

    .icon_quan {
      @include BgImage(14px, 16px, 'pay/coupon/coupon-pulldown/coupon-unselect.svg?v=1');
      margin: 0 6px 0 18px;
    }

    .coupon-name {
      border: none !important;
    }

    .coupon-count-down {
      span {
        font-size: 12px;
        color: #C36F43;
        line-height: 16px;
      }
    }
  }

  .coupon-list-wrap {
    width: 328px;
    max-height: 298px;
    background: #FFFFFF;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    position: relative;
    z-index: 10;
    padding: 14px 0 14px 14px;
    box-sizing: border-box;
    @include Position(1, 5, 130px, 50%);
    transform: translateY(-50%);
    display: none;

    /*&:before {
      content: '';
      display: inline-block;
      width: 10px;
      height: 10px;
      background-color: #FFFFFF;
      box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
      @include Position(1, 5, 24px, -5px);
      transform: rotateZ(135deg);
    }

    &:after {
      content: '';
      display: inline-block;
      width: 100px;
      height: 10px;
      background-color: #FFFFFF;
      @include Position(1, 5, 0px, 0px);
    }*/


    .title {
      font-size: 13px;
      color: #4C4B51;
      line-height: 18px;
      margin-bottom: 12px;
    }

    .coupon-list {
      max-height: 240px;
      overflow-y: scroll;
      margin-right: 6px;

      .coupon-item {
        display: flex;
        align-items: center;
        flex-direction: row;
        //justify-content: space-between;
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }


        .icon-user-radio {
          font-size: 16px;
          color: #E0E3E9;
          margin-right: 14px;
        }

        .coupon-item-info {
          @include BgImage(264px, 72px, 'pay/coupon/coupon-pulldown/coupon-item.png');
          position: relative;
          display: flex;

          .line {
            height: 44px;
            border-left: 1px dashed #E0E3E9;
            @include Position(1, 5, 94px, 50%);
            transform: translateY(-50%);
          }

          .coupon-item-info-left {
            width: 94px;
            text-align: center;

            .price-wrap {
              margin-top: 4px;
              font-size: 0;

              .icon_dollar {
                font-size: 10px;
                font-weight: bold;
                color: #F3341D;
                line-height: 14px;
                vertical-align: 2px;
                margin-right: 4px;
              }

              .price {
                font-size: 30px;
                font-weight: bold;
                color: #F3341D;
                line-height: 40px;

                &.price-zk{
                  font-size: 28px;
                }
                &.price-mysy{
                  font-size: 18px;
                }
              }

              .txt-zhe{
                font-size: 12px;
                color: #F3341D;
                margin-left: 2px;
              }
            }

            .coupon-item-type {
              font-size: 12px;
              color: #F3591D;
              line-height: 16px;
            }
          }

          .coupon-item-info-right {
            padding: 17px 0 0 15px;

            .coupon-name {
              font-size: 13px;
              color: #6F3904;
              line-height: 19px;
              margin-bottom: 4px;
            }

            .coupon-time {
              font-size: 12px;
              color: #AA7C4D;
              line-height: 16px;
            }

          }

        }


        &.active {
          display: flex;

          .icon-user-radio2 {
            color: #E94856;
          }

          .coupon-item-info {
            @include BgImage(264px, 72px, 'pay/coupon/coupon-pulldown/coupon-item@active.png');
            position: relative;
            display: flex;

            .line {
              border-color: #D5B087;
            }
          }
        }
      }
    }
  }

  @include ElementHover('', '') {

    &:after {
      content: '';
      display: inline-block;
      width: 100%;
      height: 30px;
      @include Position(1, 4, 0, -30px);
      z-index: 20;
    }

    .icon-a-arrowupbold {
      transition: all 0.3s ease-in;
      display: inline-block;
      transform: rotateZ(90deg) !important;
    }
    .coupon-list-wrap {
      display: block;
    }
  }

}

/* 自定义浏览器滚动条 */

.coupon-list {
  //scrollbar-color: #1890FF #91D5FF; /* 第一个方块颜色，第二个轨道颜色(用于更改火狐浏览器样式) */
  scrollbar-color: #E0E3E9 #FFFFFF; /* 第一个方块颜色，第二个轨道颜色(用于更改火狐浏览器样式) */
  scrollbar-width: thin; /* 火狐滚动条无法自定义宽度，只能通过此属性使滚动条宽度变细 */
  -ms-overflow-style: none; /* 隐藏滚动条（在IE和Edge两个浏览器中很难更改样式，固采取隐藏方式） */

  /* 以下是chrome浏览器自定义滚动条样式方式 */
  &::-webkit-scrollbar { /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
    border-radius: 3px;
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    //background: #1890FF;
    background: #E0E3E9;
  }

  &::-webkit-scrollbar-track { /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    border-radius: 3px;
    //background: #91D5FF;
    background: #FFFFFF;
  }
}


</style>
